import { GlButton, GlIcon, GlSkeletonLoader, GlTooltipDirective } from '@gitlab/ui';
import { isLoggedIn } from '~/lib/utils/common_utils';
import { s__ } from '~/locale';
import ImportedBadge from '~/vue_shared/components/imported_badge.vue';
import TodosToggle from '../../shared/todos_toggle.vue';
import ArchiveDesignButton from '../archive_design_button.vue';
import CloseButton from './close_button.vue';
import DesignNavigation from './design_navigation.vue';
export default {
    name: 'DesignToolbar',
    i18n: {
        downloadButtonLabel: s__('DesignManagement|Download design'),
        hideCommentsButtonLabel: s__('DesignManagement|Hide comments'),
        showCommentsButtonLabel: s__('DesignManagement|Show comments'),
        archiveButtonLabel: s__('DesignManagement|Archive design')
    },
    components: {
        GlButton,
        GlIcon,
        GlSkeletonLoader,
        ImportedBadge,
        CloseButton,
        DesignNavigation,
        TodosToggle,
        ArchiveDesignButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        design: {
            type: Object,
            required: true
        },
        designFilename: {
            type: String,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        isLatestVersion: {
            type: Boolean,
            required: true
        },
        isSidebarOpen: {
            type: Boolean,
            required: true
        },
        allDesigns: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        currentUserDesignTodos: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        canUpdateDesign: {
            type: Boolean,
            required: false
        },
        isTodoUpdating: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'archive-design',
        'toggle-todo',
        'toggle-sidebar'
    ],
    computed: {
        isLoggedIn () {
            return isLoggedIn();
        },
        toggleCommentsButtonLabel () {
            return this.isSidebarOpen ? this.$options.i18n.hideCommentsButtonLabel : this.$options.i18n.showCommentsButtonLabel;
        }
    }
};
